import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { propBool, propFunc, propId, } from '../../../../helpers/custom-prop-types';
import SubmitButton from '../../../Ui/Button/SubmitButton';
const SeminarOneSticky = (props) => {
    const { id, loading, onSubmit } = props;
    return (_jsx("div", Object.assign({ className: 'sticky-footer client_seminar_one_sticky' }, { children: _jsxs("div", Object.assign({ className: 'footer-action client_seminar_one_sticky_inner' }, { children: [_jsx(Link, Object.assign({ className: clsx('button client_seminar_one_sticky_prev', loading && 'disabled event_none'), to: `/seminar/${id}/request` }, { children: _jsx("span", { children: "\u524D\u306B\u623B\u308B" }) })), _jsx(SubmitButton, { buttonType: 'button', className: 'button primary client_seminar_one_sticky_next', isDisabled: loading, isLoading: loading, onControlClick: onSubmit, tabIndex: 0, text: '送信する' })] })) })));
};
SeminarOneSticky.propTypes = {
    id: propId().isRequired,
    loading: propBool().isRequired,
    onSubmit: propFunc().isRequired,
};
export default SeminarOneSticky;
